var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJointtype(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.92188 2.40967H13.1719C13.3376 2.40967 13.4966 2.47552 13.6138 2.59273C13.731 2.70994 13.7969 2.86891 13.7969 3.03467V13.0347C13.7969 13.2004 13.731 13.3594 13.6138 13.4766C13.4966 13.5938 13.3376 13.6597 13.1719 13.6597H1.92188C1.75611 13.6597 1.59714 13.5938 1.47993 13.4766C1.36272 13.3594 1.29688 13.2004 1.29688 13.0347V3.03467C1.29688 2.86891 1.36272 2.70994 1.47993 2.59273C1.59714 2.47552 1.75611 2.40967 1.92188 2.40967ZM12.5469 7.40967H2.54688V12.4097H12.5469V7.40967ZM12.5469 6.15967V3.65967H2.54688V6.15967H12.5469ZM8.79688 9.90967H11.2969V11.1597H8.79688V9.90967Z",
    fill: "#3AA64C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJointtype);
export default __webpack_public_path__ + "static/media/jointtype.ae3b8d2d5a445da96e15b36c15784234.svg";
export { ForwardRef as ReactComponent };